export var DepositAndWithdrawType;
(function (DepositAndWithdrawType) {
    DepositAndWithdrawType[DepositAndWithdrawType["SELF"] = 1] = "SELF";
    DepositAndWithdrawType[DepositAndWithdrawType["THIRD_PARTY"] = 2] = "THIRD_PARTY";
    DepositAndWithdrawType[DepositAndWithdrawType["MANUAL"] = 3] = "MANUAL";
    DepositAndWithdrawType[DepositAndWithdrawType["AGENT_TRANSFER_DEPOSIT"] = 4] = "AGENT_TRANSFER_DEPOSIT";
    DepositAndWithdrawType[DepositAndWithdrawType["AGENT_WALLET"] = 5] = "AGENT_WALLET";
})(DepositAndWithdrawType || (DepositAndWithdrawType = {}));
//# sourceMappingURL=DepositAndWithdrawType.js.map